import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Section = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
`;

export const SectionHeader = styled.div<{ variant?: 'primary' | 'success' | 'dark' }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin: -16px -16px 16px -16px;
  border-radius: 16px 16px 0 0;
  background: ${props => {
    switch (props.variant) {
      case 'success': return 'linear-gradient(135deg, #10b981 0%, #059669 100%)';
      case 'dark': return 'linear-gradient(135deg, #334155 0%, #475569 100%)';
      default: return 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
    }
  }};
  
  h4 {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const Badge = styled.span`
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
`;

export const PanProfBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
`;

export const PanProfLabel = styled.span`
  font-size: 10px;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const PanProfTags = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const PanProfTag = styled.span<{ $status: 'done' | 'pending' }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 11px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;

  ${props => props.$status === 'done' ? `
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  ` : `
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffc107;
  `}

  em {
    font-style: normal;
    text-decoration: underline;
  }
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  
  .icon {
    font-size: 20px;
    color: #2563eb;
  }
  
  span {
    flex: 1;
    font-size: 13px;
    color: #1e40af;
    line-height: 1.4;
    
    strong {
      font-weight: 600;
    }
  }
`;

export const BtnFixed = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 12px;
  z-index: 100;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    
    &:disabled {
      background: #94a3b8;
      box-shadow: none;
    }
    
    &:hover:not(:disabled) {
      box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
    }
  ` : `
    background: white;
    border: 2px solid #e2e8f0;
    color: #475569;
    
    &:hover {
      border-color: #94a3b8;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(30, 58, 95, 0.3);
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderAvatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const HeaderText = styled.div`
  h3 {
    margin: 0;
    color: white;
    font-size: 16px;
    font-weight: 600;
  }
  
  p {
    margin: 4px 0 0 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
  }
`;

export const HeaderStats = styled.div`
  display: flex;
  gap: 16px;
`;

export const HeaderStat = styled.div`
  text-align: center;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  
  .value {
    color: #10b981;
    font-size: 18px;
    font-weight: 700;
  }
  
  .label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

